import { z } from 'zod';

/** Human labels are metadata, never an OS rename or an authorization identifier. */
export const displayNameSchema = z.object({ displayName: z.string().trim().max(120)
  .refine(s => !/[\p{Cc}\p{Cf}\p{Zl}\p{Zp}]/u.test(s), 'Use a single line without control or formatting characters').nullable() }).strict();
export const supportIdSchema = z.string().trim().regex(/^\d{3}-?\d{3}$/).transform(s => s.replace('-', ''));
export const formatSupportId = (id: string) => `${id.slice(0, 3)}-${id.slice(3)}`;
export const deviceTitle = (device: { displayName?: string | null; hostname: string }) => device.displayName || device.hostname;
export const deviceDescription = (device: { displayName?: string | null; hostname: string }) =>
  device.displayName ? `${device.displayName} (${device.hostname})` : device.hostname;

export const jobDeviceDescription = (job: { deviceTitle: string | null; deviceHostname?: string | null; deviceDisplayName?: string | null }) =>
  deviceDescription({ hostname: job.deviceHostname ?? job.deviceTitle ?? 'Removed device', displayName: job.deviceDisplayName });
